import transl from '../components/NotAvailableText/NotAvailableText.transl'

function valueIsInContent(content, filter) {
  return content.toString().toLowerCase().includes(filter.toLowerCase())
}
/*
 * Determines if each row contains the filter value
 * @param {string} filter - The words the filter against
 * @param {Object} valuesObj - Contains the values of each column for a row
 * @returns {boolean}
 */
export default function rowFilterHelper(filter, valuesObj) {
  const notAvailableTranslation = transl.notAvailable()
  if (filter !== '') {
    return Object.values(valuesObj).some((content) => {
      switch (true) {
        // If content is null, undefined, empty object, or empty array
        case content === '':
        case content === null || content === undefined:
        case Array.isArray(content) && content.length === 0:
        case content && typeof content === 'object' && Object.values(content).length === 0:
          if (notAvailableTranslation) {
            return valueIsInContent(notAvailableTranslation, filter)
          }
          return false
        // If content is a string or number
        case typeof content === 'string' || typeof content === 'number':
          return valueIsInContent(content, filter)
        // If content is an array
        case Array.isArray(content):
          return content
            .map((obj) => {
              return Object.values(obj).flat().toString().toLowerCase().includes(filter.toLowerCase())
            })
            .includes(true)
        // If content is a simple object
        case typeof content === 'object':
          return valueIsInContent(Object.values(content), filter)
        default:
          return false
      }
    })
  }
  return true
}
